import React from 'react';
import './../App.css';
import logo from '../images_sj/Logo Shree Jeen Interiors.svg';
import { Link } from 'react-scroll';

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'home',
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const header = document.getElementById("header");
    if (window.scrollY > 20) {
      header.className = "fixed-top header header-scroll";
    } else {
      header.className = "fixed-top header";
    }
  };

  handleSetActive = (tab) => {
    this.setState({ activeTab: tab });
  };

  show = () => {
    const x = document.getElementById("myLinks");
    x.style.display = x.style.display === "block" ? "none" : "block";
  };

  render() {
    const { activeTab } = this.state;
    const tabs = [
      { name: 'home', label: 'HOME' },
      { name: 'about', label: 'ABOUT US' },
      { name: 'services', label: 'SERVICES' },
      { name: 'design-collection', label: 'PORTFOLIO' },
      { name: 'testimonials', label: 'TESTIMONIALS' },
      { name: 'contact', label: 'CONTACT US' },
    ];

    return (
      <div id="header" className="fixed-top header">
        {/* Phone number on top right - DESKTOP ONLY */}
        <div className="header-phone desktop-show">
          <a href="tel:+919828544225">
            <i className="fa fa-phone"></i>
            +91 98285 44225
          </a>
        </div>
        
        <div className="row m-0 p-0">
          <div className="col-sm col-md-1" />
          <div className="col-md-1 mobile-hide">
            <img className="header-logo" src={logo} alt="Shree Jeen Interiors Logo" />
          </div>
          <div className="col-md-2" />
          <div className="col-sm-5 col-md-8 p-0 desktop-show">
            <nav className="my-2 my-md-0 mr-md-3 tabs">
              {tabs.map(tab => (
                <Link
                  key={tab.name}
                  className={`home-tab ${activeTab === tab.name ? 'active-tab' : ''}`}
                  to={tab.name}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  onClick={() => this.handleSetActive(tab.name)}
                >
                  {tab.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>

        {/* Mobile View */}
        <div className="mobile-show">
          <div className="mobile-header-container">
            {/* Logo in mobile view */}
            <div className="mobile-logo-container">
              <img className="header-logo" src={logo} alt="Shree Jeen Interiors Logo" />
            </div>
            
            {/* Right side container for phone and hamburger - moved left */}
            <div className="mobile-right-container">
              {/* Phone number for mobile */}
              <div className="header-phone-mobile">
                <a href="tel:+919828544225">
                  <i className="fa fa-phone"></i>
                  +91 98285 44225
                </a>
              </div>

              {/* Hamburger menu icon */}
              <div className="hamburger-container">
                <p type="button" className="icon" onClick={this.show}>
                  <i className="fa fa-bars bar-icon"></i>
                </p>
              </div>
            </div>
          </div>
          
          <div className="topnav">
            <div id="myLinks" onClick={this.show}>
              {tabs.map(tab => (
                <a key={tab.name} href={`#${tab.name}`}>{tab.label}</a>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
